import LoadingPlaceholder from "../components/loadingPlaceholder";
import { useFetch } from "../hooks";
import { Markup } from "react-render-markup";
import FetchError from "../components/fetchError";

function Regulations() {
  const { response, loading, error, retry } = useFetch("store/regulations");

  if (error)
    return (
      <FetchError message="Nie udało się wczytać regulaminu." onRetry={retry} />
    );

  if (loading || !response) return <LoadingPlaceholder />;

  return (
    <main className="content-page regulations-page">
      <article className="content-page__paper">
        <Markup markup={response.body} />
      </article>
    </main>
  );
}

export default Regulations;
